import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';

import { isPrivilegesLoaded } from '@app/collections/users';
import { isFeatureExtensionsLoaded } from '@core/settings/license-configuration';

@Injectable()
export class InitialDataGuard {
  constructor(private store: Store<{}>) {}

  private isPrivilegesLoaded$ = this.store.pipe(isPrivilegesLoaded);
  private isFeatureExtensionsLoaded$ = this.store.pipe(isFeatureExtensionsLoaded);
  private isDataReady$ = combineLatest([
    this.isPrivilegesLoaded$,
    this.isFeatureExtensionsLoaded$,
  ]).pipe(
    map(([privileges, extensions]) => !!privileges && !!extensions),
    filter((v) => v),
    first(),
  );

  canActivate(): Observable<boolean> {
    return this.isDataReady$;
  }

  canActivateChild(): Observable<boolean> {
    return this.isDataReady$;
  }
}
